// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__gWPWB","contentJP":"content_contentJP__lEQAZ"};